import store from "@redux/store";
import { UPDATE_ACCOUNT_DETAILS } from "@redux/reducers/userdetail";
var UpdateAccountDetails = /** @class */ (function () {
    function UpdateAccountDetails() {
        this.dispatch = store.dispatch;
    }
    UpdateAccountDetails.prototype.updateAccountDetails = function (data) {
        this.dispatch({
            type: UPDATE_ACCOUNT_DETAILS,
            payload: data,
        });
    };
    return UpdateAccountDetails;
}());
export default UpdateAccountDetails;
